import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="feature-search"
export default class extends Controller {
  static targets = ["input", "item", "container"]

  connect() {
    console.log("Feature search controller connected")
  }

  filter() {
    // Prüfe ob alle Targets vorhanden sind
    if (!this.hasInputTarget || !this.hasContainerTarget || !this.hasItemTarget) {
      console.error("Feature search: Required targets missing")
      return
    }

    const searchTerm = this.inputTarget.value.toLowerCase().trim()
    
    // Wenn Suchfeld leer ist, zeige alle Features
    if (searchTerm === '') {
      this.itemTargets.forEach(item => {
        item.classList.remove('hidden')
      })
      // Entferne "Keine Ergebnisse" Nachricht
      const existingMsg = document.getElementById('no-results-message')
      if (existingMsg) {
        existingMsg.remove()
      }
      return
    }

    let visibleCount = 0

    // Filtere Features nach Titel oder Slug
    this.itemTargets.forEach(item => {
      const title = item.dataset.featureTitle?.toLowerCase() || ''
      const slug = item.dataset.featureSlug?.toLowerCase() || ''
      
      // Suche in Titel UND Slug
      if (title.includes(searchTerm) || slug.includes(searchTerm)) {
        item.classList.remove('hidden')
        visibleCount++
      } else {
        item.classList.add('hidden')
      }
    })

    // Optional: Zeige eine "Keine Ergebnisse" Nachricht
    if (visibleCount === 0 && !document.getElementById('no-results-message')) {
      const gridContainer = this.containerTarget.querySelector('.grid')
      if (gridContainer) {
        const noResultsMsg = document.createElement('div')
        noResultsMsg.id = 'no-results-message'
        noResultsMsg.className = 'col-span-2 text-center py-8 text-gray-500'
        noResultsMsg.innerHTML = `
          <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 class="mt-2 text-sm font-medium text-gray-900">Keine Features gefunden</h3>
          <p class="mt-1 text-sm text-gray-500">Versuchen Sie einen anderen Suchbegriff.</p>
        `
        gridContainer.appendChild(noResultsMsg)
      }
    } else if (visibleCount > 0) {
      // Entferne "Keine Ergebnisse" Nachricht wenn Ergebnisse gefunden werden
      const existingMsg = document.getElementById('no-results-message')
      if (existingMsg) {
        existingMsg.remove()
      }
    }
  }
}
